<span class="ft-stat-expand-cell" [class.-clickable]="clickable">
    <span class="ft-stat-expand-cell_label">{{ label }}</span>
    <!-- Expand icon (four corner arrows). Present on clickable cells at half opacity; ramps to
         full opacity on hover (matches the Figma "drill button"). -->
    <mat-icon *ngIf="clickable" class="ft-stat-expand-cell_icon" [svgIcon]="'expand'"></mat-icon>
    <span class="ft-stat-expand-cell_value">{{ value | number: digitsInfo }}</span>
</span>
<!-- Optional content under the value (e.g. a YOY delta line). -->
<ng-content></ng-content>
